<template>
  <v-menu offset-y>
    <template #activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-btn color="error" light @click="archiveWorkspace">
      <v-icon>delete</v-icon>
      &nbsp; Archive Workspace
    </v-btn>
  </v-menu>
</template>
<script setup>
// eslint-disable-next-line no-undef
const emit = defineEmits(['archive-workspace']);

const archiveWorkspace = () => {
  emit('archive-workspace');
};
</script>
